import React, { useContext, useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import UserContext from '../../contexts/UserContext'
import { hasModulePermission, getModulesForTenantWithPermissions, getModulesForTenant } from '../../config/modulesByTenant'
import { useTenant } from '../../contexts/TenantContext'
import GlobalLoadingOverlay from '../GlobalLoadingOverlay'

interface PermissionGuardProps {
  children: React.ReactNode
  permission: string
  dependencies?: string[]
  redirectTo?: string
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
  children,
  permission,
  dependencies = [],
  redirectTo = '/panel'
}) => {
  const { user, token, isLoadingAuth } = useContext(UserContext)
  const { tenantId } = useTenant()
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    if (!isLoadingAuth && token) {
      const timer = setTimeout(() => {
        setIsChecking(false)
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [isLoadingAuth, token])

  if (isLoadingAuth || isChecking) {
    return <GlobalLoadingOverlay />
  }

  if (token && tenantId === null) {
    return <GlobalLoadingOverlay />
  }

  if (token && (!user || (!user.id && !user.sub))) {
    return <GlobalLoadingOverlay />
  }

  if (!user.permissions) {
    return <Navigate to={redirectTo} replace />
  }

  const hasPermission = () => {
    if (tenantId === 2) {
      if (user.permissions.includes(permission)) {
        return true
      }
      
      if (permission === 'router' || permission === 'services') {
        return true
      }
      
      return false
    }
    
    const moduleConfig = {
      name: '',
      path: '',
      image: '',
      section: '',
      permission,
      dependencies: dependencies.length > 0 ? dependencies : undefined
    }
    
    return hasModulePermission(moduleConfig, user.permissions)
  }

  if (!hasPermission()) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}

export default PermissionGuard
